var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-footer__content"},[_c('Link',{staticClass:"dropdown-footer___content-link",attrs:{"href":_vm.url,"is-unstyled":""}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('GradientIcon',{attrs:{"name":"ArrowRight"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }